export const isDebug = process.env.NODE_ENV !== 'production';
